import { useEffect, useState } from "react";
import { Highlight } from "@/components/Highlight";

export function Drawer({ id, onClose }: { id: string; onClose: () => void }) {
  const [d, setD] = useState<any>(null);
  const [thread, setThread] = useState<any[] | null>(null);
  const [issues, setIssues] = useState<any[]>([]);
  const [issueSel, setIssueSel] = useState("");
  const [issueMsg, setIssueMsg] = useState("");
  useEffect(() => {
    fetch("/api/v1/issues").then((r) => (r.ok ? r.json() : { data: [] })).then((j) => setIssues((j.data ?? []).filter((x: any) => x.status !== "closed")));
  }, []);
  useEffect(() => {
    setD(null); setThread(null); setIssueMsg("");
    fetch(`/api/v1/mentions/${id}`).then((r) => r.json()).then((j) => {
      setD(j.data);
      if (j.data?.vendor === "neticle" && j.data?.threadId) {
        fetch(`/api/v1/mentions?thread=${encodeURIComponent(j.data.threadId)}&page=1&pageSize=100&start=2000-01-01&end=2100-01-01&sourceType=twitter,instagram,facebook,tiktok,youtube,blog,forum,other,news_online`)
          .then((r) => r.ok ? r.json() : { data: [] }).then((t) => setThread((t.data ?? []).sort((a: any, b: any) => +new Date(a.publishedAt) - +new Date(b.publishedAt))));
      }
    });
  }, [id]);
  const pdf = Array.isArray(d?.attachments) ? d.attachments.find((x: any) => x?.type === "pdf") : null;
  const isPrint = d?.sourceType === "print";
  return (
    <>
      <div className="avio-scrim" onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 40 }} />
      <div style={{ position: "fixed", top: 0, right: 0, bottom: 0, width: "min(620px,94vw)", background: "var(--color-surface)", borderLeft: "1px solid var(--color-border)", boxShadow: "-18px 0 44px -28px rgba(16,24,40,.65)", padding: "var(--space-8)", overflowY: "auto", zIndex: 50 }}>
        <button className="avio-btn" data-variant="ghost" data-size="sm" onClick={onClose} style={{ float: "right" }} title="Tutup"><i className="fa-solid fa-xmark" /></button>
        {!d ? <p>memuat…</p> : (
          <>
            <h3 style={{ marginTop: 0, paddingRight: 30, lineHeight: 1.35 }}><Highlight text={d.title} /></h3>
            <p style={{ color: "var(--color-text-secondary)", fontSize: "var(--text-sm)" }}>
              {new Date(new Date(d.publishedAt).getTime() + 7 * 3600e3).toISOString().slice(0, 16).replace("T", " ")} WIB
              {" · "}{isPrint ? "Cetak" : d.sourceType === "tv" ? "TV" : "Online"}
              {d.journalist ? ` · ${d.journalist}` : ""}
              {d.pageNumber ? ` · hal. ${d.pageNumber}` : ""}
            </p>
            {d.vendor === "neticle" && (
              <p style={{ fontSize: 13, color: "var(--color-text-secondary)", background: "var(--color-surface-sunken)", borderRadius: "var(--radius-sm)", padding: "var(--space-4) var(--space-5)", display: "inline-block" }}>
                {[
                  d.likes != null ? `Likes ${Intl.NumberFormat("id-ID", { notation: "compact" }).format(d.likes)}` : null,
                  d.comments != null ? `Komentar ${Intl.NumberFormat("id-ID", { notation: "compact" }).format(d.comments)}` : null,
                  d.shares != null ? `Share ${Intl.NumberFormat("id-ID", { notation: "compact" }).format(d.shares)}` : null,
                  d.dislikes ? `Dislike ${Intl.NumberFormat("id-ID", { notation: "compact" }).format(d.dislikes)}` : null,
                  d.reactions ? `Reaksi ${Intl.NumberFormat("id-ID", { notation: "compact" }).format(d.reactions)}` : null,
                  d.interactions != null ? `Total ${Intl.NumberFormat("id-ID", { notation: "compact" }).format(d.interactions)}` : null,
                  d.reach != null ? `reach ${Intl.NumberFormat("id-ID", { notation: "compact" }).format(d.reach)}` : null,
                  d.engagementRate != null ? `ER ${(d.engagementRate * 100).toFixed(2)}%` : null,
                ].filter(Boolean).join("  ·  ")}
              </p>
            )}
            <div style={{ display: "flex", gap: 6, alignItems: "center", margin: "0 0 12px", flexWrap: "wrap" }}>
              <i className="fa-solid fa-fire-extinguisher" style={{ fontSize: 13, color: "#b00020" }} />
              <select value={issueSel} onChange={(e) => setIssueSel(e.target.value)} style={{ fontSize: 12.5, maxWidth: 240 }}>
                <option value="">Tautkan ke issue…</option>
                {issues.map((x: any) => <option key={x.id} value={x.id}>{x.title}</option>)}
                <option value="__new__">+ Issue baru dari item ini</option>
              </select>
              <button onClick={async () => {
                if (!issueSel) return;
                if (issueSel === "__new__") {
                  const t = prompt("Judul issue baru:", d.title?.slice(0, 80) ?? "");
                  if (!t) return;
                  const r = await fetch("/api/v1/issues", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ title: t, mentionId: d.id }) });
                  const j = await r.json();
                  if (r.ok) location.href = `/a/issues/${j.data.id}`; else setIssueMsg(j.error);
                  return;
                }
                const r = await fetch(`/api/v1/issues/${issueSel}/link`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ mentionId: d.id }) });
                setIssueMsg(r.ok ? "tertaut (OK)" : "gagal");
              }} style={{ fontSize: 12.5, padding: "5px 12px", cursor: "pointer", background: "var(--color-text-link)", color: "#fff", border: 0, borderRadius: 6 }}>Tautkan</button>
              <span style={{ fontSize: 12, color: "var(--sent-pos)" }}>{issueMsg}</span>
            </div>
            {isPrint && pdf && (
              <a href={`/api/v1/assets/media/${pdf.vendorPath}`} target="_blank" rel="noreferrer"
                 style={{ display: "inline-block", padding: "8px 14px", background: "var(--color-text-link)", color: "#fff", borderRadius: 4, textDecoration: "none", marginBottom: 14 }}>
                Buka PDF Halaman Cetak
              </a>
            )}
            {!isPrint && d.url && <p style={{ marginTop: 0 }}><a href={d.url} target="_blank" rel="noreferrer">Buka sumber asli ↗</a></p>}
            {Array.isArray(d.quotes) && d.quotes.length > 0 && (
              <div style={{ background: "#f6f8fc", borderLeft: "3px solid #1F3864", padding: "10px 14px", marginBottom: 12 }}>
                <b>Narasumber:</b>
                {d.quotes.map((q: any) => (
                  <p key={q.id} style={{ margin: "6px 0" }}><b>{q.personName}</b>{q.quote ? <>: “<Highlight text={q.quote} />”</> : null}</p>
                ))}
              </div>
            )}
            {thread && thread.length > 1 && (
              <div style={{ background: "#f6f8fc", borderRadius: 6, padding: "10px 12px", marginBottom: 12 }}>
                <b style={{ fontSize: 13 }}><i className="fa-solid fa-comments" /> Percakapan ({thread.length} item)</b>
                <div style={{ display: "grid", gap: 4, marginTop: 6, maxHeight: 220, overflowY: "auto" }}>
                  {thread.map((t: any) => (
                    <div key={t.id} style={{ paddingLeft: t.isReply ? 18 : 0, fontSize: 13, borderLeft: t.id === d.id ? "3px solid #1F3864" : "3px solid transparent", background: t.id === d.id ? "#eef2fa" : undefined, borderRadius: 3, padding: "2px 4px 2px " + (t.isReply ? "18px" : "6px") }}>
                      <span style={{ color: "var(--color-text-muted)", fontSize: 11 }}>{new Date(new Date(t.publishedAt).getTime() + 7 * 3600e3).toISOString().slice(5, 16).replace("T", " ")}</span>{" "}
                      <i className={t.isReply ? "fa-solid fa-reply" : "fa-solid fa-comment-dots"} style={{ color: t.isReply ? "var(--mark-c2)" : "var(--color-text-link)", fontSize: 11 }} />{" "}
                      {t.authorHandle && <b>@{t.authorHandle}: </b>}
                      {(t.title || "").slice(0, 90)}
                    </div>
                  ))}
                </div>
              </div>
            )}
            <p style={{ whiteSpace: "pre-wrap", lineHeight: 1.7, fontSize: 15 }}>{d.content ? <Highlight text={d.content} /> : "(konten tidak tersedia)"}</p>
          </>
        )}
      </div>
    </>
  );
}
